// extracted by mini-css-extract-plugin
export default {"popularLinks":"vpv5G","link":"Af00L","label":"L1Je4","container":"pL3lm"};